import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "@reduxjs/toolkit";
import starIcon from "../../assets/star_icon.svg";
import {  getInhouseArtistsThunk } from "../../slices/events/thunk";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { 
  createParticipateContestThunk as onCreateParticipateContestThunk, 
  resetContestThunk as onResetContest 
} from "../../slices/contest/thunk";

const AvailableArtist = ({ contestId , participants}) => {
  const dispatch = useDispatch();
  const [loadingArtistId, setLoadingArtistId] = useState(null);
    const [artists, setArtists] = useState([]);
  
 const navigate = useNavigate();
  const selectArtistState = (state) => state.user;
  const artistSelector = createSelector(selectArtistState, (artist) => ({
    isLoading: artist.isLoading,
    users: artist.users,
  }));

  const { users } = useSelector(artistSelector);
  const fileUrl = process.env.REACT_APP_FILE_URL;

  //isParticipate
  const selectContestState = (state) => state.contest;
  const contestSelector = createSelector(selectContestState, (contest) => ({
    isParticipate: contest.isParticipate,
  }));

    const { isParticipate } = useSelector(contestSelector);

  useEffect(() => {
    if (contestId) {
      // dispatch(getUserListThunk({ userType: 2, contest_id: contestId,isInHouseArtist:2 }));
      fetchArtistList();
    }
    // console.log("participants in available artist component");
    // console.log(participants);
  }, [dispatch, contestId, isParticipate]);

  useEffect(() => {
    
    if (isParticipate) {
      setLoadingArtistId(null);
    }
  }, [isParticipate]);

  const handleHireArtist = (artistId) => {
    // console.log({'contestId':contestId, 'artistId':artistId,'is_accept':3,'is_user_request':1});
    setLoadingArtistId(artistId);
    dispatch(onResetContest());
    dispatch(onCreateParticipateContestThunk({'contestId':contestId, 'artistId':artistId,'is_accept':3,'is_user_request':1})).unwrap().then((res) => {
     navigate('/user/my-contests');
  });
}

  // Determine if any artist is hired or requested (to disable others)
  const hasHiredOrRequested = artists?.some(
    (u) => u.participateInContest == '1' || u.participateInContest == '3'
  );


    //fetch artist list inhouse
  const fetchArtistList = async () => {
    try {
      const res = await dispatch(getInhouseArtistsThunk()).unwrap();
      console.log("In-house artists:", res.data);
      //now we need to set artists in dropdown
      setArtists(res.data);
      //we need to find for which artist we have refferal code in our local storage and then we need to set that artist as selected in dropdown
// console.log(res.data);
      try {

        // we need to sync our artist list with the participant list we have in contest detail to show the correct status of each artist in dropdown
        if (participants && participants.length > 0) {
          const updatedArtists = res.data.map(artist => {
            const participant = participants.find(p => p.artist_id === artist.id);
            if (participant) {
              return { ...artist, participateInContest: participant.is_accept };
            }
            return artist;
          });
          setArtists(updatedArtists);
          // console.log("Updated artists with participation status:", updatedArtists);
        }

       
      } catch (e) { }


    }catch (e) { };
}

  return (
    <>
      

      <div className="w-full rounded-[14px] py-3 px-3 sm:px-[15px] ">
        
        {artists?.map((user) => {
          const profilePic = user.artistImage ? `${fileUrl}/${user.artistImage}` : null;
          const status = user.participateInContest;
          let buttonLabel = "Hire";
          let isDisabled = false;
          let buttonStyle = "bg-transparent border border-secondary text-secondary";

          switch (status) {
            case '1':
              buttonLabel = "Hired";
              isDisabled = true;
              buttonStyle = "bg-secondary text-white";
              break;
            case '2':
              buttonLabel = "Rejected";
              isDisabled = true;
              buttonStyle = "bg-transparent text-red-500 border border-red-500";
              break;
            case '3':
              buttonLabel = "Requested";
              isDisabled = true;
              buttonStyle = "bg-transparent text-primary border border-primary ";
              break;
            default:
              buttonLabel = "Get Hire";
              isDisabled = hasHiredOrRequested; // disable if another artist is hired/requested
              buttonStyle = "bg-transparent border border-border_color text-secondary";
          }

          return (
            <div key={user.id} className="w-full">
              <div className="w-full flex items-center justify-between">
                {/* Left Side */}
                <div className="flex items-center gap-2">
                  <div className="w-[50px] h-[50px] sm:w-[69px] sm:h-[69px] p-[2px] border-2 border-secondary rounded-full flex items-center justify-center overflow-hidden">
                      <img
                        src={profilePic}
                        alt="Profile"
                        className="w-full h-full object-cover rounded-full"
                      />
                  </div>
                  <div>
                    <div className="flex items-center gap-1 sm:gap-2 flex-wrap">
                      <p className="text-[12px] sm:text-[16px] text-black font-bold font-grotesk">
                        {user.artistName}
                      </p>
                      <span className="hidden xs:block">
                        {/* <img src={starIcon} alt="Star" /> */}
                      </span>
                    </div>
                    <p className="text-[10px] sm:text-sm text-secondary font-bold font-grotesk ">
                      {user.available ? "Available" : "Not available"}
                    </p>
                  </div>
                </div>

                {/* Right Side */}
                <div>
                 <button
  disabled={isDisabled || loadingArtistId === user.id || user.available == false}
  onClick={() => handleHireArtist(user.id)}
  className={`min-w-[70px] sm:min-w-[95px] py-3 text-sm font-bold px-2 sm:px-5 font-grotesk rounded-[10px] tracking-wide transition duration-300 whitespace-nowrap relative flex items-center justify-center
    ${
      isDisabled || loadingArtistId === user.id || user.available == false
        ? "bg-gray-400 cursor-not-allowed opacity-60"
        : `${buttonStyle} hover:opacity-90`
    }
  `}
>
                    {loadingArtistId === user.id ? (
                      <div className="flex items-center justify-center">
                        <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                      </div>
                    ) : (
                      buttonLabel
                    )}
                  </button>
                </div>
              </div>
              <hr className="mt-4 mb-4" />
            </div>
          );
        })}
      </div>
    </>
  );
};

export default AvailableArtist;
